<template>
  <div class="addUserDialog">
    <el-dialog
      :title="title"
      :visible.sync="dialogFormVisible"
      width="800px"
      :close-on-click-modal="false"
      class="addUser"
      :before-close="handleCloseDialog"
      :show-close="false"
      :lock-scroll="false"
    >
      <div class="formBox">
        <el-form ref="userForm" :model="userForm" class="compForm">
          <div class="left">
            <el-form-item prop="name">
              <el-input
                v-model="userForm.name"
                placeholder="姓名"
                clearable
                class="input-width"
              ></el-input>
            </el-form-item>
            <el-form-item prop="idCard">
              <el-input
                v-model="userForm.idCard"
                placeholder="身份证号"
                clearable
                class="input-width"
              ></el-input>
            </el-form-item>
            <el-form-item prop="certifiterList">
              <el-cascader
                v-model="userForm.jobList"
                placeholder="证书名称和登记"
                :options="certifiterList"
                :show-all-levels="true"
                class="input-width"
                :props="{
                  checkStrictly: true,
                  value: 'jobId',
                  label: 'jobName',
                  children: 'levelList',
                }"
                clearable
                @change="handleJobLevelChange"
              ></el-cascader>
              <i
                class="el-icon-plus"
                style="font-size:18px;margin-left:10px;cursor: pointer;"
                @click="handleOpenJobFn"
              ></i>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="userForm.applicationTime"
                type="date"
                class="input-width"
                value-format="yyyy-MM-dd"
                placeholder="报考时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item prop="money">
              <el-input
                v-model="userForm.money"
                placeholder="金额"
                clearable
                class="input-width"
                @keyup.native="userForm.money = inputChange(userForm.money)"
              ></el-input>
            </el-form-item>
          </div>
          <div class="right">
            <el-form-item prop="phone">
              <el-input
                v-model="userForm.phone"
                placeholder="手机号"
                clearable
                class="input-width"
              ></el-input>
            </el-form-item>
            <el-form-item prop="company">
              <el-input
                v-model="userForm.company"
                placeholder="公司名称"
                clearable
                class="input-width"
              ></el-input>
            </el-form-item>
            <el-form-item prop="channel">
              <el-input
                v-model="userForm.channel"
                placeholder="渠道"
                clearable
                class="input-width"
              ></el-input>
            </el-form-item>
            <el-form-item prop="salesman">
              <el-input
                v-model="userForm.salesman"
                placeholder="业务员"
                clearable
                class="input-width"
              ></el-input>
            </el-form-item>
            <el-form-item prop="state">
              <el-select v-model="userForm.state" placeholder="状态" class="input-width">
                <el-option :value="1" label="未安排"></el-option>
                <el-option :value="2" label="已考试"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div class="importfile">
          <div class="text">考生附件：</div>
          <el-upload
            ref="upload"
            action="/api/third/api/tencentUpload/upload/file/local"
            :on-remove="handleRemove"
            accept=".zip,.doc,.docx,.pdf,.png,.jpg,.jpge"
            :limit="100"
            :multiple="true"
            :file-list="fileList"
            :on-progress="handleUploadProress"
            :on-success="handleUploadSuccess"
          >
            <el-button type="primary">上传附件</el-button>
          </el-upload>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleCloseDialog">取消</el-button>
        <el-button type="primary" @click="handleSubmitFn">确定</el-button>
      </div>
    </el-dialog>
    <JobLevel ref="JobLevel" @success="getJobLevel"></JobLevel>
  </div>
</template>
<script>
import to from 'await-to'
import { applyInfoQuery, applyInfoAdd, applyInfoEdit } from '@/api/apply'
import { filterJobLevel } from '@/api/exam'
import JobLevel from './jobAdd'
export default {
  name: 'AddUser',
  components: {
    JobLevel,
  },
  data() {
    return {
      dialogFormVisible: false,
      title: '添加考生信息',
      userForm: {},
      id: '',
      certifiterList: [],
      fileList: [],
      appendixFileList: [],
    }
  },
  methods: {
    show(id) {
      this.dialogFormVisible = true
      this.getJobLevel()
      this.id = id
      if (this.id) {
        this.handleGetApplyUserQuery(id)
      } else {
        this.title = '添加考生信息'
      }
    },
    handleOpenJobFn() {
      this.$refs.JobLevel.show()
    },
    handleSubmitFn() {
      if (this.id) {
        this.handleApplyEditFn()
      } else {
        this.handleApplyAddFn()
      }
    },
    async handleApplyAddFn() {
      this.userForm.appendixList = this.appendixFileList
      const [, err] = await to(applyInfoAdd({ ...this.userForm }))
      if (err) return this.$message.warning(err.msg)
      this.$message.success('添加成功')
      this.$emit('success')
      this.dialogFormVisible = false
      this.userForm = {}
      this.fileList = []
      this.appendixFileList = []
    },
    async handleApplyEditFn() {
      this.userForm.appendixList = this.appendixFileList
      const [, err] = await to(applyInfoEdit({ ...this.userForm }))
      if (err) return this.$message.warning(err.msg)
      this.$message.success('编辑成功')
      this.$emit('success')
      this.dialogFormVisible = false
      this.userForm = {}
      this.fileList = []
      this.appendixFileList = []
    },
    async getJobLevel() {
      const [res, err] = await to(filterJobLevel({}))
      if (err) return this.$message.warning(err.msg)
      this.certifiterList = res.data
    },
    handleJobLevelChange(value) {
      if (value && value.length > 0) {
        if (value.length == 1) {
          this.userForm.jobId = value[0]
          this.userForm.jobLevel = ''
        } else if (value.length == 2) {
          this.userForm.jobId = value[0]
          this.userForm.jobLevel = String(value[value.length - 1])
        }
      } else {
        this.userForm.jobId = ''
        this.userForm.jobLevel = ''
      }
    },
    async handleGetApplyUserQuery(id) {
      const [res, err] = await to(applyInfoQuery({ id: id }))
      if (err) return this.$message.warning(err.msg)
      this.userForm = res.data
      this.title = '编辑考生信息'
      if (res.data.appendixList && res.data.appendixList.length) {
        res.data.appendixList.forEach(item => {
          item.name = item.fileName
          item.url = item.fileUrl
        })
      }
      this.fileList = res.data.appendixList
      this.appendixFileList = [...this.fileList]
    },
    //效验输入框
    inputChange(num) {
      let str = num.toString()
      var len1 = str.substr(0, 1)
      var len2 = str.substr(1, 1)
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != '.') {
        str = str.substr(1, 1)
      }
      if (len1 == '.') {
        str = ''
      }
      //限制只能输入一个小数点
      if (str.indexOf('.') != -1) {
        var str_ = str.substr(str.indexOf('.') + 1)
        if (str_.indexOf('.') != -1) {
          str = str.substr(0, str.indexOf('.') + str_.indexOf('.') + 1)
        }
        if (str_.length > 2) {
          this.$message.warning(`金额小数点后只能输入两位，请正确输入！`)
          return (str = '')
        }
      }
      //正则替换
      str = str.replace(/[^\d.]/g, '') // 保留数字和小数点
      return str
    },
    handleCloseDialog() {
      this.dialogFormVisible = false
      this.userForm = {}
      this.fileList = []
      this.appendixFileList = []
    },
    handleUploadProress({ percent }) {
      console.log(`output->percent`, percent)
      this.$emit('progress', percent)
    },
    async handleUploadSuccess(response, fileList) {
      console.log(`output->'成功'`, '成功', response, fileList)
      this.appendixFileList.push({
        name: fileList.name,
        url: response.data,
        fileName: fileList.name,
        fileUrl: response.data,
      })
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
      this.appendixFileList = [...this.fileList]
    },
  },
}
</script>
<style lang="scss" scoped>
.addUser {
  ::v-deep .el-dialog {
    .el-dialog__body {
      padding: 30px 50px;
      .el-form {
        display: flex;
        justify-content: space-between;
        .input-width {
          width: 320px;
        }
      }
      .importfile {
        display: flex;
        margin-top: 20px;
        .text {
          font-size: 16px;
          line-height: 36px;
          margin-right: 20px;
          flex-shrink: 0;
        }
        .el-button {
          width: 170px;
          height: 36px;
          border-radius: 2px;
          font-weight: normal;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
